module.exports = __webpack_public_path__ + "static/media/foto_brahma_06.1f65a8bc.jpg";